import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { RouterService } from '@app/core/services/router.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { PeziButtonComponent } from '../../pezi-button/pezi-button.component';

@UntilDestroy()
@Component({
  selector:    'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  standalone: true,
  imports:    [
    CdkScrollable,
    MatDialogContent,
    NgIf,
    MatDialogActions,
    PeziButtonComponent,
    MatDialogClose
  ]
})
export class ConfirmDialogComponent  {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData, public dialogRef: MatDialogRef<ConfirmDialogComponent>, private router: Router,
    private routerService: RouterService) { }





  public navigateHome(): void {
    this.routerService.navigateHomeNewTab();
  }

}

export const ACCEPT = 'accept';

export interface ConfirmDialogData {
  text: string;
  showHomeButton?: boolean;
}
